export enum SubscriptionStatus {
  created = 'CREATED',
  pending = 'PENDING',
  rejected = 'REJECTED',
  active = 'ACTIVE',
  expired = 'EXPIRED',
  revoked = 'REVOKED',
  suspended = 'SUSPENDED',
  pastDue = 'PAST_DUE',
  unpaid = 'UNPAID',
  finished = 'FINISHED',
  canceled = 'CANCELED',
  error = 'ERROR',
  declined = 'DECLINED',
}
